import type { PreviousModality } from "@repo/contract/training";
import { "improve.modality.question" as modalityQuestion } from "@repo/i18n";
import { useCallback } from "react";
import { MultiChips } from "../../../ui/controls";
import { modalityOptions } from "./options";

export interface ModalitiesFormProps {
  onChange: (value: PreviousModality[]) => void;
  value: readonly PreviousModality[];
}

/**
 * "O que você já treinou?" — several may apply, or `none`. Ticking `none`
 * clears the rest, and ticking anything clears `none`: both at once is an
 * answer that contradicts itself.
 */
export function exclusiveNone(
  previous: readonly PreviousModality[],
  next: readonly PreviousModality[]
): PreviousModality[] {
  const added = next.filter((m) => !previous.includes(m));
  if (added.includes("none")) {
    return ["none"];
  }
  return next.filter((m) => m !== "none");
}

export function ModalitiesForm({ value, onChange }: ModalitiesFormProps) {
  const change = useCallback(
    (next: PreviousModality[]) => onChange(exclusiveNone(value, next)),
    [onChange, value]
  );
  return (
    <MultiChips
      label={modalityQuestion()}
      onValueChange={change}
      options={modalityOptions()}
      value={value}
    />
  );
}
